import{defineMessages}from"react-intl";export const messages=defineMessages({noDetails:{id:"jutro-dataview.Expansion.noDetails",defaultMessage:"No details"}});